// ============================================================
// EDIT THIS FILE with your actual hospital/clinic details.
// These values are used as the letterhead on every generated
// bill/invoice PDF and on the printed bill form.
// ============================================================

const hospitalInfo = {
    name: "Green Naturopathy",
    centreName: "GREEN NATUROPATHY",
    tagline: "Pain Clinic & Holistic Healthcare",
    addressLine1: "194-C, SATHY ROAD, NEAR PASUMAI PHARMACY, BHARATHI NAGAR",
    addressLine2: "GOPALAKRISHNAPURAM, GANAPATHY, COIMBATORE, TAMIL NADU 641006",
    city: "Coimbatore",
    state: "Tamil Nadu",
    pincode: "641006",
    phone: "9345316319",
    email: "greennaturopathycbe@gmail.com",
    website: "https://greennaturopathy.com",
    websiteDisplay: "greennaturopathy.com",
    googleReviewUrl: "https://g.page/r/CfNAbnnuCG74EAI/review",
    gstin: "", // leave blank if not applicable
    logoUrl: "/images/logo-light.jpg" // optional - path/URL to a logo image, used in the PDF if provided
};

export default hospitalInfo;
